import { i18n } from '@/plugins/vue-i18n';
import store from '@/store';

/*
 * @param {SearcherResult} content
 * @return {SelectableListItem}
 */
export function SearcherSelectionItemMapper({ entity }) {
  const id = entity.id || entity.entityId;
  const type = entity.type || entity.entityType;
  const config = type ? store.getters.getWizard(type) || {} : {};
  return {
    id,
    icon: config.icon,
    type: [
      `message.type.${type}`,
      `message.wizard.${type}`,
      `message.entity.type.${type}`,
    ].find(translation => i18n.te(translation)) || type,
    title: entity.name || entity.title || entity.description,
    entity,
  };
}

export default {
  SearcherSelectionItemMapper,
};
